import { createSlice } from '@reduxjs/toolkit';
import { omit } from 'ramda';
import { AddNoticeAction, DeleteNoticeAction, NoticesState } from './types';

let nextId = 0;

const name = 'notices';
const initialState: NoticesState = { noticeData: {}, noticeQueue: [] };

export const { reducer, actions } = createSlice({
  name,
  initialState,
  reducers: {
    addNotice: (state, action: AddNoticeAction) => {
      const id = action.payload.id ?? `notice-${nextId++}`;
      state.noticeData[id] = omit(['id'], action.payload);
      if (!state.noticeQueue.includes(id)) state.noticeQueue.push(id);
    },

    deleteNotice: (state, action: DeleteNoticeAction) => {
      delete state.noticeData[action.payload.id];
      state.noticeQueue = state.noticeQueue.filter((n) => n !== action.payload.id);
    },
  },
});
